module.exports = __webpack_public_path__ + "static/img/Jobe.Watson.d902a90.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jobe.Watson.jpg
// module id = /8ul
// module chunks = 0